import { sendPostRequest } from "services/apiService";

interface IPlaceTicketOrder {
  status: boolean;
}

interface IRequest {
  eventId: string;
}

const request = async (orderReference: string, eventId: string) => {
  const resp = await sendPostRequest<IRequest, APIResponse<IPlaceTicketOrder>>(
    `/ticket-order/${orderReference}`,
    { eventId },
  );

  if (!resp.isSuccess) {
    throw new Error(resp?.message ?? resp?.error);
  }

  return resp;
};

export default request;
